import { Injectable, Signal, computed, signal } from '@angular/core';

import { LoaderKey } from '../enums';

export interface GrLoaderEntry {
  key: LoaderKey;
  fullscreen: boolean;
  label: string;
}

export interface GrShowLoaderOptions {
  fullscreen?: boolean;
  label?: string;
}

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly entries = signal<ReadonlyMap<LoaderKey, GrLoaderEntry>>(new Map());

  readonly global = computed<GrLoaderEntry | null>(() => this.entries().get(LoaderKey.GLOBAL) ?? null);

  show(key: LoaderKey, options: GrShowLoaderOptions = {}): void {
    const next = new Map(this.entries());
    next.set(key, {
      key,
      fullscreen: key === LoaderKey.GLOBAL || options.fullscreen === true,
      label: options.label ?? '',
    });
    this.entries.set(next);
  }

  hide(key: LoaderKey): void {
    const current = this.entries();
    if (!current.has(key)) return;
    const next = new Map(current);
    next.delete(key);
    this.entries.set(next);
  }

  isActive(key: LoaderKey): Signal<boolean> {
    return computed(() => this.entries().has(key));
  }

  entry(key: LoaderKey): Signal<GrLoaderEntry | null> {
    return computed(() => this.entries().get(key) ?? null);
  }
}
